import React from 'react';
import HeroImage from 'assets/landing/banner/custom-made-rack.png'; // replace with your actual image path
import Logo from 'assets/logo.png'; // replace with your actual logo
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const HeroBanner = ({ hero, product }) => {
  const heroRef = useRef(null);

  const navigate = useNavigate();

  return (
    <section
      ref={heroRef}
      className="flex flex-col md:flex-row w-full  md:h-screen overflow-hidden"
    >
      {/* === Left side content === */}
      <div className=" my-12 mx-auto flex flex-col justify-center items-center bg-[#FFF6F2] px-8 sm:px-16 md:w-1/2 space-y-6">
        <motion.img
          src={hero?.image}
          alt="Ayinza Logo"
          className="h-16 sm:h-80 w-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        />

        <motion.p
          className="text-2xl sm:text-3xl tracking-wide text-gray-700 just-me-again-down-here-regular"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {hero?.caption}
        </motion.p>

        <motion.a
          className="bg-[#AC3F1E] text-white uppercase text-sm sm:text-base tracking-wide px-6 py-3"
          whileHover={{ scale: 1.05 }}
          href={hero?.buttonUrl}
          whileTap={{ scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          {hero?.buttonLabel}
        </motion.a>
      </div>

      {/* === Right side image background === */}
      <div
        className="relative flex items-center justify-center md:w-1/2  md:h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${product?.image})`,
        }}
      >
        {/* Black overlay box */}
        <div className="absolute inset-0 bg-black opacity-60"></div>

        {/* Content Box */}
        <motion.div
          className="relative z-10 bg-black/70 text-white p-6 sm:p-10 max-w-sm sm:max-w-md rounded-none"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl font-semibold mb-3 text-[#F8AF10] just-me-again-down-here-regular">
            {hero?.productLabel}
          </h2>
          <p className="text-sm sm:text-base mb-5 leading-relaxed">{hero?.productCaption}</p>
          <motion.button
            className="border border-white text-[#F8AF10] font-bold w-full text-start uppercase text-sm tracking-wide px-4 py-2 hover:bg-[#AC3F1E] hover:border-[#AC3F1E] transition"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(`/products/${product?.slug}`)}
          >
            Check it out →
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};
